import { Card, CardContent, ProgressBar, Text } from "@prismicio/editor-ui"

import type { OnboardingStep, OnboardingTracking } from "../../service"
import { OnboardingTutorial } from "../components/OnboardingTutorial"
import { OnboardingProgressStepper } from "./OnboardingProgressStepper"

interface OnboardingCardProps {
  steps: OnboardingStep[]
  completedSteps: string[]
  tutorialLink?: string
  tracking: OnboardingTracking
  onToggleStep: (step: OnboardingStep) => Promise<void>
  onClose?: () => void
}
export function OnboardingCard(props: OnboardingCardProps) {
  const {
    steps,
    completedSteps,
    tutorialLink,
    tracking,
    onToggleStep,
    onClose
  } = props

  return (
    <Card
      color="grey2"
      variant="animated-light"
      paddingBlock={16}
      onClose={onClose}
    >
      <CardContent>
        <div>
          <Text variant="bold">
            {`Build your first page in ${steps.length.toString()} simple steps`}
          </Text>
          <Text color="grey11" variant="small">
            Render a live page with content coming from Prismic.
          </Text>
        </div>
        <ProgressBar
          value={completedSteps.length}
          max={steps.length}
          displayLabel
          getValueLabel={(value, max) => `${value}/${max}`}
        />
        <OnboardingProgressStepper
          steps={steps}
          completedSteps={completedSteps}
          onToggleStep={onToggleStep}
          tracking={tracking}
        />
        {tutorialLink && <OnboardingTutorial href={tutorialLink} />}
      </CardContent>
    </Card>
  )
}
